import { AsyncPipe, NgFor } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { FieldType } from '@ngx-formly/core';
import { Observable, debounceTime, distinctUntilChanged, map, of, startWith, switchMap } from 'rxjs';

@Component({
    selector: 'sl-select-search',
    templateUrl: './select-search.component.html',
    styleUrls: ['./select-search.component.less'],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        NgFor,
        MatOptionModule,
        AsyncPipe,
    ],
})
export class SelectSearchComponent extends FieldType implements OnInit {
	@ViewChild('select') select: MatSelect;
	filterCtrl: UntypedFormControl = new UntypedFormControl();
	filteredOptions!: Observable<any[]>;

	ngOnInit(): void {
		const optionsSource = this.props.options instanceof Observable ? this.props.options : of(this.props.options || []);

		this.filteredOptions = this.filterCtrl.valueChanges.pipe(
			startWith(''),
			debounceTime(200),
			distinctUntilChanged(),
			switchMap((text) => optionsSource.pipe(map((options) => this.filterOptions(text, options))))
		);

		this.filterCtrl.valueChanges.pipe(debounceTime(200), distinctUntilChanged()).subscribe(() => {
			this.select.open();
		});
	}

	private filterOptions(filter: string, options: any[]): any[] {
		const filterValue = filter.toLowerCase();
		return options.filter((option) => option.label.toLowerCase().includes(filterValue));
	}

	open() {
		this.select.open();
	}
}
